var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcUserLine24X24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 25",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 11.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM20 19.5a7.987 7.987 0 0 0-3.475-6.592M4 19.5c0-4.42 3.58-8 8-8M20 19.5c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2",
  stroke: "#222B3E",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIcUserLine24X24;